/**
 * Number of columns that fit a given container width, mirroring CSS
 * `grid-template-columns: repeat(auto-fill, minmax(minCardWidth, 1fr))`.
 */
export function computeColumns(
  containerWidth: number,
  minCardWidth: number,
  gap: number
): number {
  if (containerWidth <= 0) return 1;
  return Math.max(1, Math.floor((containerWidth + gap) / (minCardWidth + gap)));
}

/** Splits `items` into consecutive rows of at most `columnsPerRow` items each. */
export function chunkIntoRows<T>(items: T[], columnsPerRow: number): T[][] {
  if (columnsPerRow <= 0) return [items];
  const rows: T[][] = [];
  for (let i = 0; i < items.length; i += columnsPerRow) {
    rows.push(items.slice(i, i + columnsPerRow));
  }
  return rows;
}

/**
 * Walks up from `element` to find the nearest ancestor that scrolls
 * (`overflow-y: auto | scroll`), falling back to the document's own
 * scrolling element for pages that scroll at the window level.
 */
export function findScrollParent(element: HTMLElement | null): HTMLElement {
  let node = element?.parentElement ?? null;
  while (node) {
    const { overflowY } = getComputedStyle(node);
    if (overflowY === "auto" || overflowY === "scroll") return node;
    node = node.parentElement;
  }
  return (
    (document.scrollingElement as HTMLElement | null) ??
    document.documentElement
  );
}
